import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowLeftRightOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="m22 6.636-5.636 5.637L15.09 11l3.463-3.463H3v-1.8h15.555L15.09 2.273 16.364 1z"
                    fill="currentColor"
                />
                <path
                    d="M2 17.364 7.636 23l1.273-1.273-3.463-3.463H21v-1.8H5.445L8.91 13l-1.273-1.273z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ArrowLeftRightOutlinedSize24Glyph.displayName = 'ArrowLeftRightOutlinedSize24Glyph';
